const spineZones = [
  {
    id: "corpusVertebrae",
    value: "Тело позвонка",
    color: "#8B0000",
  },
  {
    id: "osteophyte",
    value: "Остеофит",
    color: "#800080",
  },
  {
    id: "intervertebralDisc",
    value: "Межпозв. диск",
    color: "#5F9EA0",
  },
];

export default spineZones;
